import { localStorageKey } from ".";

const LOCAL_STORAGE_REDIRECTION_URL_KEY = "redirect";

interface IRedirectionLocalStorageObject {
  queryString: string;
  confirmed?: boolean;
}

export const getPersistedRedirectionUrl = (): IRedirectionLocalStorageObject => {
  const value = window.localStorage.getItem(localStorageKey(LOCAL_STORAGE_REDIRECTION_URL_KEY));

  if (value) {
    return JSON.parse(value);
  }

  return { queryString: "" };
};

export const persistRedirectionUrl = (redirectionObject: IRedirectionLocalStorageObject) => {
  if (redirectionObject.queryString === "") {
    return;
  }
  window.localStorage.setItem(
    localStorageKey(LOCAL_STORAGE_REDIRECTION_URL_KEY),
    JSON.stringify(redirectionObject)
  );
};

export const confirmPersistedRedirectionUrl = () => {
  const storedRedirectionObject = getPersistedRedirectionUrl();
  if (!storedRedirectionObject || storedRedirectionObject.queryString === "") {
    return;
  }

  storedRedirectionObject.confirmed = true;
  persistRedirectionUrl(storedRedirectionObject);
};

export const deleteRedirectionUrl = () => {
  window.localStorage.removeItem(localStorageKey(LOCAL_STORAGE_REDIRECTION_URL_KEY));
};
